<template>
  <div class="leilao">
    <v-container
      class="lighten-5 mt-6 mb-6 pt-12 pb-16"
      fluid
    >
      <v-row>
        <v-col
          cols="3"
        >
          <v-navigation-drawer
            permanent
            width="100%"
          >
            <v-card-title>
              Filtros:
            </v-card-title>
            <v-card-text>
              <v-select
                :items="orderBy"
                label="Ordenar por:"
                chips
                persistent-hint
              ></v-select>
              <v-select
                :items="artistics"
                label="Artistas"
                multiple
                chips
                persistent-hint
              ></v-select>
              <v-select
                :items="categorys"
                label="Categoria"
                multiple
                chips
                persistent-hint
              ></v-select>
            </v-card-text>
          </v-navigation-drawer>
        </v-col>
        <v-col>
          <v-row
            no-gutters
          >
            <v-col>
              <div class="fill-height pa-2">
                <v-row>
                  <v-col
                    v-for="(lote, index) of lots"
                    :key="index"
                    class="col-3"
                  >
                    <v-card
                      class="mx-auto fill-height"
                      outlined
                    >
                      <v-img
                        src="https://via.placeholder.com/686x400"
                      ></v-img>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1">
                            {{ lote.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="lote.artist">
                            {{ lote.artist.name }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            {{ lote.description }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-card-actions>
                        <v-btn
                          outlined
                          text
                          @click="gotoLote(lote)"
                        >
                          Ver Lote
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RegisterMixin from '@/mixins/RegisterMixin';
import AuctionsService from '@/services/AuctionsService';

export default {
  name: 'Home',
  components: {
  },
  mixins: [RegisterMixin],
  data() {
    return {
      e7: '',
      orderBy: ['A-Z', 'Destaques', 'Artistas', 'Menor Preço', 'Maior Preço'],
      artistics: ['Artista 1', 'Artista 2', 'Artista 3', 'Artista 4', 'Artista 5'],
      categorys: ['Categoria 1', 'Categoria 2', 'Categoria 3', 'Categoria 4', 'Categoria 5'],
    };
  },
  computed: {
    ...mapState('Data/Auctions', [
      'auction',
      'auctions',
      'lots',
    ]),
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    if (!this.auction) {
      AuctionsService.setAuction({
        id: this.$route.params.leilao,
        slug: this.$route.params.leilao,
      });
    }
    AuctionsService.getAuctionDetails();
    AuctionsService.getAuctionsLots();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    gotoLote(lote) {
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          leilao: this.auction.slug,
          lote: lote.order,
        },
      });
    },
    logOut() {
      this.$router.push({ name: this.$consts.ROUTES.AUTH_LOGIN.NAME });
    },
  },
};
</script>
<style lang='scss'>
@import '@/static/css/Variables.scss';
</style>
